import DocumentsStatusTable from "./DocumentsStatusTable";

export default DocumentsStatusTable;
